import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from "react";

/**
 * Use the window object in a safe way.
 * @param {string} path
 * @param {any} alternative
 */
export default function useWindow(path, alternative) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    set = _useState2[1];
  useEffect(function () {
    var v = window;
    path && (v = path.split(".").reduce(function (o, k) {
      return o !== undefined ? o[k] : undefined;
    }, v));
    set(v);
  }, [path]);
  return val === undefined ? alternative : val;
}
//# sourceMappingURL=useWindow.js.map